import { CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'angular-calendar';
import { DirectivesModule } from '../../theme/directives/directives.module';
import { EmployeeRoutingModule } from './employee-routing.module';
import { EmployeeComponent } from './employee.component';
import { EmployeeCreateEditComponent } from './employee-create-edit/employee-create-edit.component';
import { EmployeeListComponent } from './employee-list/employee-list.component';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { ColumnChooserService, FilterService, GridAllModule, GridModule, PageService, ReorderService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import {SwitchModule} from '@syncfusion/ej2-angular-buttons'
import { MyDatePickerModule } from 'mydatepicker';
import { PayRatesEditComponent } from './pay-rates-edit/pay-rates-edit.component';
import { PayRatesListComponent } from './pay-rates-list/pay-rates-list.component';
import { EmployeeService } from './employee.service';
import { ClientEmployeeContactModule } from '../client-employee-contact/client-employee-contact.module';
import { EmployeepayrateService } from './employeepayrate.service';
import { EmployeePayrollService } from './employee-payroll/employee-payroll.service';

import { EmployeeworkHistoryService } from './employee-payroll/employee-payrolllhistory.service';
import { ClientEmployeeRelationshipModule } from '../client-employee-relationship/client-employee-relationship.module';
import { EmployeeAgreementlistModule } from '../employee-agreementlist/employee-agreementlist.module';
import { PayorRequiredIdsEditComponent } from './payor-required-ids-edit/payor-required-ids-edit.component';
import { PayorRequiredIdsListComponent } from './payor-required-ids-list/payor-required-ids-list.component';
import { GetEmployeeservice } from './employeedata.service';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { EmployeeNotesComponent } from './employee-notes/employee-notes.component';
import { EmployeePayrollComponent } from './employee-payroll/employee-payroll.component';
import { ClientEmployeeDynamicFormModule } from '../client-employee-dynamicform/client-employee-dynamicform.module';
import { UsersHttpService } from '../users/users.service';
import { GoogleMapModule } from '../google-map/google-map.module';

@Injectable({
  providedIn: 'root'
})

@NgModule({
  
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    DirectivesModule,
    EmployeeRoutingModule,
    GridModule,
    GridAllModule,
    NgSelectModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ReactiveFormsModule,
    SwitchModule,
    MyDatePickerModule,
    PDFExportModule,
    EmployeeAgreementlistModule,
    ClientEmployeeContactModule,
    ClientEmployeeRelationshipModule,
    
    ClientEmployeeDynamicFormModule,
    GoogleMapModule,
 //   RouterModule.forChild(routes)
  ],
  declarations: [
    EmployeeComponent,
    EmployeeCreateEditComponent,
    EmployeeListComponent,
    PayRatesEditComponent,
    PayRatesListComponent,
    PayorRequiredIdsEditComponent,
    PayorRequiredIdsListComponent,
    EmployeeNotesComponent,
    EmployeePayrollComponent
  ],
  providers: [GetEmployeeservice,EmployeeService,EmployeepayrateService,EmployeeworkHistoryService,EmployeePayrollService,
    ColumnChooserService,PageService,SortService,FilterService,ResizeService ,UsersHttpService,ReorderService],
 schemas:[CUSTOM_ELEMENTS_SCHEMA],
})
export class EmployeeModule { }
